module.exports = __webpack_public_path__ + "img/d0ce3e9.jpg";